import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@stratascratch/ui';
import ResultsTable from './ResultsTable';
import './ExpectedOutput.css';
function ExpectedOutput({ loading, results, isGraph = false }) {
    if (loading)
        return _jsx(Skeleton, { className: "ExpectedOutput__loader" });
    if (!results)
        return null;
    return (_jsxs(_Fragment, { children: [!isGraph && (_jsx("p", { className: "ExpectedOutput__message", children: "All required columns and the first 5 rows of the solution are shown" })), _jsx(ResultsTable, { results: results, className: "ExpectedOutput__results-table" })] }));
}
export default ExpectedOutput;
//# sourceMappingURL=ExpectedOutput.js.map